export const isVenueGroupsEnabled = () =>
  typeof venueGroupsEnabled !== "undefined" && venueGroupsEnabled === true;

export const getVenueGroupsMaxMembers = () =>
  typeof venueGroupsMaxMembers === "number" && venueGroupsMaxMembers > 0
    ? venueGroupsMaxMembers
    : 1;
